import { Box, Heading, Text, Image, Flex, Button, Link, useMediaQuery, theme } from "@chakra-ui/react";
import React from "react";
import { responsiveValue } from "../../assets/style/defaultTheme";
import { PostBasicStyle } from "../../Container/Board/View/style";
import { lineBreakToBr } from "../../util";

type Props = {
	title: string;
	content: string;
	featured_full: string;
	displayButton?: boolean;
	detailButtonLabel?: string;
	url?: string;
	target?: string;
};

function FormHeader({ title, content, featured_full, displayButton, url, target, detailButtonLabel }: Props) {
	const { flexBoxDirection } = responsiveValue;
	const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	return (
		<Box maxW="1200px" w="100%">
			<Flex justify="space-between" direction={flexBoxDirection}>
				{featured_full && !isMobile && <Image src={featured_full} w={isMobile ? "100%" : "49%"} objectFit="cover" />}
				<Box maxW={isMobile ? "100%" : "49%"}>
					<Heading size="3xl" pb="4">
						{title}
					</Heading>
					{featured_full && isMobile && <Image src={featured_full} w={isMobile ? "100%" : "49%"} objectFit="cover" pb={isMobile ? "8" : "0"} />}
					<PostBasicStyle noPad={true} dangerouslySetInnerHTML={{ __html: lineBreakToBr(content) }} />
					{displayButton && url && (
						<div>
							<Box textAlign="center">
								<Link href={url} target={target}>
									<Button mt={4} size="md" colorScheme="dgr" type="button">
										{detailButtonLabel ? detailButtonLabel : "자세히 보기"}
									</Button>
								</Link>
							</Box>
						</div>
					)}
				</Box>
			</Flex>
		</Box>
	);
}

FormHeader.defaultProps = {};

export default FormHeader;
